<template>
  <div
    v-if="visible"
    class="actual-rent-tooltip"
    :class="{ 'actual-rent-tooltip--line': mode === 'line' }"
    :style="{ left: left + 'px', top: top + 'px' }"
  >
    <template v-if="mode === 'actual-rent'">
      <div class="actual-rent-tooltip-header">
        <div class="actual-rent-tooltip-name">
          {{ item ? item.name : '' }}
        </div>
      </div>
      <div class="actual-rent-tooltip-body">
        <div class="actual-rent-tooltip-grid">
          <div>
            <div class="actual-rent-tooltip-label">Arrival:</div>
            <div class="actual-rent-tooltip-value">
              {{ item ? item.arrival || '—' : '—' }}
            </div>
          </div>
          <div>
            <div class="actual-rent-tooltip-label">Departure:</div>
            <div class="actual-rent-tooltip-value">
              {{ item ? item.departure || '—' : '—' }}
            </div>
          </div>
          <div>
            <div class="actual-rent-tooltip-label">Guests:</div>
            <div class="actual-rent-tooltip-value">
              {{ item ? item.guests || '—' : '—' }}
            </div>
          </div>
          <div>
            <div class="actual-rent-tooltip-label">Price:</div>
            <div class="actual-rent-tooltip-value">
              {{ item ? formatCurrency(item.value) : '$' }}
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="actual-rent-tooltip-header">
        <div class="actual-rent-tooltip-name">{{ lineLabel }}</div>
      </div>
      <div class="actual-rent-tooltip-body actual-rent-tooltip-body--line">
        <div class="actual-rent-tooltip-label">Date:</div>
        <div class="actual-rent-tooltip-value">{{ dateLabel || '—' }}</div>
        <div class="actual-rent-tooltip-label">Price:</div>
        <div class="actual-rent-tooltip-value">
          {{ formatCurrency(lineValue) }}
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'ActualRentTooltip',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'actual-rent'
    },
    left: {
      type: Number,
      default: 0
    },
    top: {
      type: Number,
      default: 0
    },
    item: {
      type: Object,
      default: null
    },
    lineLabel: {
      type: String,
      default: ''
    },
    lineValue: {
      type: Number,
      default: null
    },
    dateLabel: {
      type: String,
      default: ''
    }
  },
  methods: {
    formatCurrency(value) {
      if (value == null || value === '') return '$'
      const n = Number(value)
      if (Number.isNaN(n)) return '$'
      return `$${n.toFixed(2)}`
    }
  }
}
</script>

<style scoped>
.actual-rent-tooltip {
  position: fixed;
  z-index: 9999;
  width: 280px;
  max-width: calc(100vw - 32px);
  background: #ffffff;
  border: 1px solid rgba(88, 135, 234, 0.5);
  border-radius: 7px;
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.11);
  padding: 12px 14px;
  transform: translate(-50%, calc(-100% - 9px));
  pointer-events: none;
}

.actual-rent-tooltip--line {
  width: 195px;
}

.actual-rent-tooltip-body--line {
  display: grid;
  grid-template-columns: auto 1fr;
  column-gap: 10px;
  row-gap: 7px;
  align-items: baseline;
}

.actual-rent-tooltip-header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 7px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e9e9e9;
}

.actual-rent-tooltip-name {
  font-family: Montserrat;
  font-size: 15px;
  font-weight: 700;
  color: #111111;
  line-height: 1.15;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.actual-rent-tooltip-body {
  padding-top: 8px;
}

.actual-rent-tooltip-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 14px;
  row-gap: 8px;
}

.actual-rent-tooltip-label {
  font-family: Montserrat;
  font-size: 12px;
  font-weight: 400;
  color: #9b9b9b;
  line-height: 1.2;
  margin-bottom: 3px;
}

.actual-rent-tooltip-value {
  font-family: Montserrat;
  font-size: 13px;
  font-weight: 700;
  color: #111;
  line-height: 1.25;
}

@media screen and (max-width: 768px) {
  .actual-rent-tooltip {
    width: min(220px, calc(100vw - 20px));
    max-width: calc(100vw - 20px);
    padding: 12px 14px;
    transform: translate(-50%, calc(-100% - 8px));
  }

  .actual-rent-tooltip-name {
    font-size: 13px;
  }

  .actual-rent-tooltip-label {
    font-size: 11px;
    margin-bottom: 2px;
  }

  .actual-rent-tooltip-value {
    font-size: 12px;
  }

  .actual-rent-tooltip-grid {
    column-gap: 10px;
    row-gap: 6px;
  }
}
</style>
